import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { scale } from "utils"
import PlSeparator from "./PlSeparator"

const PlTestPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printerWidth
  } = props

  const [t] = useTranslation()

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOther

  return (
    <Fragment>
      <div style={styles["text"]}>
        {t("لورم_ایپسوم_متن_ساختگی_با_تولید_سادگی_نامفهوم_از_صنعت_چاپ_و_با_استفاده_از_طراحان_گرافیک_است_چاپگرها_و_متون_بلکه_روزنامه_و_مجله_در_ستون_و_سطرآنچنان_که_لازم_است_و_برای_شرایط_فعلی_تکنولوژی_مورد_نیاز_و_کاربردهای_متنوع_با_هدف_بهبود_ابزارهای_کاربردی_می_باشد_جوابگوی_سوالات_پیوسته_اهل_دنیای_موجود_طراحی_اساسا_مورد_استفاده_قرار_گیرد")}
      </div>
      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  text: {
    fontSize: scale("19px", printerWidth)
  }
})

const stylesOther = {
  text: {
    marginRight: "8px",
    fontSize: "11px"
  }
}

export default PlTestPrintTemplate